import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor() { }
  private menuTitleSource = new BehaviorSubject<string>('Gestion des clients'); 
  menuTitle$ = this.menuTitleSource.asObservable(); 

  // Méthode pour mettre à jour le titre du menu
  setMenuTitle(title: string) {
    this.menuTitleSource.next(title);
  }
}
